import { useSyncExternalStore } from "react";

let openModalCount = 0;
const listeners = new Set<() => void>();

const emit = () => {
    listeners.forEach((listener) => listener());
};

export const registerOpenModal = (): (() => void) => {
    openModalCount += 1;
    emit();
    return () => {
        openModalCount = Math.max(0, openModalCount - 1);
        emit();
    };
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

const getSnapshot = () => openModalCount > 0;
const getServerSnapshot = () => false;

export const useHasOpenModal = (): boolean =>
    useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
